import { gql } from "src/__generated__";

export const PREFILL_PORTFOLIO_FROM_CV = gql(`
	mutation PrefillPortfolioFromCV(
		$professionalSummary: String
		$educationItems: [PrefillEducationInput!]!
		$employmentHistoryItems: [PrefillEmploymentInput!]!
		$workHistoryItems: [PrefillWorkHistoryInput!]!
		$certificationItems: [PrefillCertificationInput!]!
	) {
		prefillPortfolioFromCV(
			professionalSummary: $professionalSummary
			educationItems: $educationItems
			employmentHistoryItems: $employmentHistoryItems
			workHistoryItems: $workHistoryItems
			certificationItems: $certificationItems
		) {
			educationCount
			employmentHistoryCount
			workHistoryCount
			certificationCount
			professionalSummarySet
			laborpassCompleted
		}
	}
`);

